module.exports = __webpack_public_path__ + "img/hr-V-L-6-unload-connect-shadow.96a807d4.png";